export const SpacingCard = () => {
    return (
      <div className='title__container'>
          <div className="title__wrapper">
              <img src="/img/widgets/padding.png" alt=''/>
          </div>
      </div>
    )
}